import Statistic from './Statistic';
import Countdown from './Countdown';
Statistic.Countdown = Countdown;
export default Statistic;
